<app-page-header></app-page-header>

<div class="extraction-reports-page">
  <div class="content-section">
    <div class="evaluation-section-header">
      <div class="evaluation-section-title-wrap">
        <button
          class="section-back-btn"
          (click)="goBack()"
          title="Back to Operational Health"
          aria-label="Back to Operational Health">
          <svg
            class="back-arrow-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true">
            <path d="M19 12H5"></path>
            <path d="M12 19l-7-7 7-7"></path>
          </svg>
        </button>
        <h2 class="evaluation-section-title">Extraction Reports</h2>

        <div class="extraction-search-group">
          <div class="extraction-search-field">
            <span class="material-icons search-icon" aria-hidden="true">search</span>
            <input
              class="extraction-search-input"
              type="text"
              [(ngModel)]="globalSearch"
              (ngModelChange)="onFilterChange()"
              placeholder="Search File Name, Request ID, Owner" />
          </div>
        </div>
      </div>

      <div class="header-controls-group">
        <div class="header-controls-context-slot" [class.has-custom-controls]="selectedTimeFilter === 'custom'">
          @if (selectedTimeFilter === 'custom') {
            <div class="custom-date-controls">
              <span class="date-prefix-label">From</span>
              <div class="date-time-control date-time-popup-anchor">
                <div class="date-input-wrapper">
                  <input
                    class="date-display-input"
                    type="text"
                    [value]="startDateDisplay"
                    placeholder="MM/DD/YYYY hh:mm AM/PM"
                    maxlength="22"
                    (input)="onDateInputChange('start', $event)"
                    (keydown)="onDateInputKeydown($event)"
                    (blur)="onDateInputBlur('start')"
                    (click)="openDateTimePopup('start', $event)"
                    title="Start date and time" />
                  <span class="material-icons date-picker-icon" aria-hidden="true" (click)="openDateTimePopup('start', $event)">calendar_today</span>
                </div>

                @if (isPopupOpen('start')) {
                  <div class="date-time-popup-panel" (click)="onPopupPanelClick($event)">
                    <div class="popup-calendar-wrap">
                      <mat-calendar
                        [selected]="popupDate"
                        [maxDate]="getPopupMaxDate('start')"
                        (selectedChange)="onPopupDateSelected($event)">
                      </mat-calendar>
                    </div>

                    <div class="popup-time-row" aria-label="Start time picker">
                      <select class="time-select time-select-hour" [(ngModel)]="popupHour12" (change)="onPopupTimePartChange()" title="Start hour">
                        @for (hour of hourOptions; track hour) {
                          <option [value]="hour">{{ hour }}</option>
                        }
                      </select>
                      <span class="time-separator">:</span>
                      <select class="time-select time-select-minute" [(ngModel)]="popupMinute" (change)="onPopupTimePartChange()" title="Start minute">
                        @for (minute of minuteOptions; track minute) {
                          <option [value]="minute">{{ minute }}</option>
                        }
                      </select>
                      <select class="time-select time-select-period" [(ngModel)]="popupPeriod" (change)="onPopupTimePartChange()" title="Start period">
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                }
              </div>

              <span class="date-prefix-label">To</span>
              <div class="date-time-control date-time-popup-anchor">
                <div class="date-input-wrapper">
                  <input
                    class="date-display-input"
                    [class.is-invalid]="endDateInvalid"
                    type="text"
                    [value]="endDateDisplay"
                    placeholder="MM/DD/YYYY hh:mm AM/PM"
                    maxlength="22"
                    (input)="onDateInputChange('end', $event)"
                    (keydown)="onDateInputKeydown($event)"
                    (blur)="onDateInputBlur('end')"
                    (click)="openDateTimePopup('end', $event)"
                    [attr.title]="dateRangeValidationMessage || 'End date and time'" />
                  <span class="material-icons date-picker-icon" aria-hidden="true" (click)="openDateTimePopup('end', $event)">calendar_today</span>
                </div>

                @if (isPopupOpen('end')) {
                  <div class="date-time-popup-panel" (click)="onPopupPanelClick($event)">
                    <div class="popup-calendar-wrap">
                      <mat-calendar
                        [selected]="popupDate"
                        [minDate]="getPopupMinDate('end')"
                        [maxDate]="getTodayDateForPopup()"
                        (selectedChange)="onPopupDateSelected($event)">
                      </mat-calendar>
                    </div>

                    <div class="popup-time-row" aria-label="End time picker">
                      <select class="time-select time-select-hour" [(ngModel)]="popupHour12" (change)="onPopupTimePartChange()" title="End hour">
                        @for (hour of hourOptions; track hour) {
                          <option [value]="hour">{{ hour }}</option>
                        }
                      </select>
                      <span class="time-separator">:</span>
                      <select class="time-select time-select-minute" [(ngModel)]="popupMinute" (change)="onPopupTimePartChange()" title="End minute">
                        @for (minute of minuteOptions; track minute) {
                          <option [value]="minute">{{ minute }}</option>
                        }
                      </select>
                      <select class="time-select time-select-period" [(ngModel)]="popupPeriod" (change)="onPopupTimePartChange()" title="End period">
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                }
              </div>

            </div>
          }
        </div>

        <div class="filter-select-wrapper">
          <select
            class="filter-select"
            [(ngModel)]="selectedTimeFilter"
            (change)="onTimeFilterChange()"
            title="Date filter">
            <option value="today">Last 24 Hours</option>
            <option value="last7">Last 7 Days</option>
            <option value="last30">Last 30 Days</option>
            <option value="custom">Custom</option>
          </select>
          <span class="material-icons dropdown-indicator" aria-hidden="true">arrow_drop_down</span>
        </div>
      </div>
    </div>

    @if (isLoading) {
      <div class="validation-loading-wrapper">
        <div class="page-loading-state">
          <div class="docsila-loader">
            <div class="beat-loader">
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
              <div class="beat"></div>
            </div>
            <p class="loader-text">Loading extraction report...</p>
          </div>
        </div>
      </div>
    } @else {
      <div class="validation-table-wrapper" #tableScrollHost (scroll)="onTableScroll()">
        <table class="validation-table">
          <thead>
            <tr>
              <th class="sortable" (click)="sortBy('file_name')">
                File Name <span class="sort-icon" [innerHTML]="getSortIcon('file_name')"></span>
              </th>
              <th class="sortable center" (click)="sortBy('request_id')">
                Request ID <span class="sort-icon" [innerHTML]="getSortIcon('request_id')"></span>
              </th>
              <th class="sortable center" (click)="sortBy('owner_by')">
                Owner <span class="sort-icon" [innerHTML]="getSortIcon('owner_by')"></span>
              </th>
              <th class="sortable center" (click)="sortBy('page_count')">
                Page Count <span class="sort-icon" [innerHTML]="getSortIcon('page_count')"></span>
              </th>
              <th class="sortable center" (click)="sortBy('start_date_time')">
                Start Date <span class="sort-icon" [innerHTML]="getSortIcon('start_date_time')"></span>
              </th>
              <th class="sortable center" (click)="sortBy('avg_duration_seconds')">
                Duration <span class="sort-icon" [innerHTML]="getSortIcon('avg_duration_seconds')"></span>
              </th>
              <th class="sortable center" (click)="sortBy('status')">
                Status <span class="sort-icon" [innerHTML]="getSortIcon('status')"></span>
              </th>
              <th class="center">Actions</th>
            </tr>
          </thead>

          <tbody>
            @for (row of displayedRows; track row.request_id) {
              <tr>
                <td [title]="row.file_name">{{ row.file_name }}</td>
                <td class="center" [title]="row.request_id">{{ row.request_id }}</td>
                <td class="center" [title]="row.owner_by || '-'">{{ row.owner_by || '-' }}</td>
                <td class="center">{{ row.page_count | number:'1.0-0' }}</td>
                <td class="center">{{ formatStartDateHuman(row.start_date_time) }}</td>
                <td class="center">{{ row.avg_duration_seconds | number:'1.0-2' }}s</td>
                <td class="center">
                  <div class="status-cell-content">
                    <span class="status-badge" [class]="getStatusBadgeClass(row.status)">
                      <span class="status-label">{{ getStatusDisplayLabel(row.status) }}</span>
                    <button
                      class="btn-action btn-icon-only btn-status-eye status-inline-eye"
                      [attr.data-eye-row-id]="row.request_id"
                      (click)="openDetailsPopup(row, $event)"
                      title="View Extraction Details"
                      aria-label="View Extraction Details">
                      <span class="material-icons status-eye-glyph" aria-hidden="true">info</span>
                    </button>
                    </span>
                  </div>
                </td>
                <td class="center">
                  <div class="action-buttons">
                    <button
                      class="btn-action btn-icon-only btn-view-response"
                      (click)="onViewResponse(row)"
                      title="View Response"
                      aria-label="View Response">
                      <span class="material-icons">article</span>
                    </button>
                    <button
                      class="btn-action btn-icon-only btn-download"
                      [disabled]="isRowDownloading(row)"
                      (click)="onDownloadLogs(row)"
                      title="Download Logs"
                      aria-label="Download Logs">
                      @if (isRowDownloading(row)) {
                        <span class="download-spinner" aria-hidden="true"></span>
                      } @else {
                        <span class="material-icons">download</span>
                      }
                    </button>
                    <button
                      class="btn-action btn-icon-only btn-view-extraction-data"
                      [disabled]="row.status !== 'SUCCESS'"
                      (click)="onViewExtractionData(row)"
                      [title]="row.status === 'SUCCESS' ? 'View Extraction Data' : 'Extraction data not available for ' + getStatusDisplayLabel(row.status) + ' status'"
                      aria-label="View Extraction Data">
                      <span class="material-icons">description</span>
                    </button>
                  </div>
                </td>
              </tr>
            } @empty {
              <tr class="no-results-row">
                <td class="empty-cell" colspan="8">
                  <p class="empty-state-message">No extraction reports available.</p>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="pagination-bar" aria-label="Extraction requests pagination">
        <div class="pagination-summary">
          <span>
            Showing {{ getCurrentPageStartRequestIndex() | number:'1.0-0' }}-{{ getCurrentPageEndRequestIndex() | number:'1.0-0' }} of {{ totalCount | number:'1.0-0' }} requests (Page {{ currentPage }} of {{ totalPages }})
          </span>
        </div>

        <div class="pagination-controls">
          <button
            class="pagination-btn"
            [disabled]="isLoading || currentPage <= 1"
            (click)="goToFirstPage()"
            title="First page">
            &lt;&lt;
          </button>

          <button
            class="pagination-btn"
            [disabled]="isLoading || currentPage <= 1"
            (click)="goToPage(currentPage - 1)"
            title="Previous page">
            &lt;
          </button>

          @for (page of pageNumbers; track page) {
            <button
              class="pagination-btn"
              [class.active]="page === currentPage"
              [disabled]="isLoading"
              (click)="goToPage(page)">
              {{ page }}
            </button>
          }

          <button
            class="pagination-btn"
            [disabled]="isLoading || currentPage >= totalPages"
            (click)="goToPage(currentPage + 1)"
            title="Next page">
            &gt;
          </button>

          <button
            class="pagination-btn"
            [disabled]="isLoading || currentPage >= totalPages"
            (click)="goToLastPage()"
            title="Last page">
            &gt;&gt;
          </button>
        </div>
      </div>
    }

    @if (isDetailsPopupOpen && activeDetailsRow) {
      <div
        #detailsPopup
        class="status-details-popup"
        [style.left.px]="detailsPopupPosition.left"
        [style.top.px]="detailsPopupPosition.top"
        (click)="$event.stopPropagation()">
        <h4 class="status-details-title">Extraction Details</h4>
        <div class="status-details-grid">
          <span class="status-details-label">Request ID</span>
          <span class="status-details-value">{{ displayValue(activeDetailsRow.request_id) }}</span>

          <span class="status-details-label">Client Request ID</span>
          <span class="status-details-value">{{ displayValue(activeDetailsRow.client_request_id) }}</span>

          <span class="status-details-label">Job ID</span>
          <span class="status-details-value">{{ displayValue(activeDetailsRow.job_id) }}</span>

          <span class="status-details-label">OCR cost</span>
          <span class="status-details-value">{{ displayCost(activeDetailsRow.ocr_cost) }}</span>

          <span class="status-details-label">LLM cost</span>
          <span class="status-details-value">{{ displayCost(activeDetailsRow.llm_cost) }}</span>

          <span class="status-details-label">Message</span>
          <span class="status-details-value status-details-message">{{ displayValue(activeDetailsRow.message) }}</span>
        </div>
      </div>
    }

    @if (isDownloadTypePickerOpen && downloadTargetRow) {
      <div class="download-type-overlay" (click)="closeDownloadTypePicker()">
        <div class="download-type-picker" (click)="$event.stopPropagation()">
          <h4 class="download-type-title">Download Data</h4>
          <p class="download-type-subtitle">Select the data to download for {{ downloadTargetRow.document_model || downloadTargetRow.file_name }}</p>

          <div class="download-type-options">
            @for (dataType of downloadTypeOptions; track dataType) {
              <button
                type="button"
                class="download-type-option-btn"
                [disabled]="downloadingRequestId !== null"
                (click)="onSelectDownloadType(dataType)">
                {{ getDownloadTypeLabel(dataType) }}
              </button>
            }
          </div>

          <button
            type="button"
            class="download-type-cancel-btn"
            [disabled]="downloadingRequestId !== null"
            (click)="closeDownloadTypePicker()">
            Cancel
          </button>
        </div>
      </div>
    }
  </div>
</div>

